import PinchMeAPI from "../lib/PinchMeAPI";
import {
  fetchTestimonialsPending,
  fetchTestimonialsSuccess,
  fetchTestimonialsFail
} from "../dux/testimonials";

export default function fetchTestimonials() {
  return dispatch => {
    dispatch(fetchTestimonialsPending());
    PinchMeAPI.getTestinonials()
        .then(res => {
          if (res.error) {
            throw res.error;
          }
          dispatch(fetchTestimonialsSuccess(res.testimonials));
          return res;
        })
        .catch(error => {
          dispatch(fetchTestimonialsFail(error));
        });
  };
}
